'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = configureApiReducer;

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  error: null,
  isPending: false,
  response: null
};

function configureApiReducer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      types = _ref.types;

  if ((typeof types === 'undefined' ? 'undefined' : _typeof(types)) !== 'object') {
    throw new Error('Missing `types` array.');
  } else if (!types.length || types.length !== 3) {
    throw new Error('`types` must be an array of 3 strings');
  }

  var PENDING_TYPE = types[0];
  var SUCCESS_TYPE = types[1];
  var FAILURE_TYPE = types[2];

  return function apiReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref2 = arguments[1];
    var type = _ref2.type,
        payload = _ref2.payload;

    switch (type) {
      case PENDING_TYPE:
        return (0, _objectAssign2.default)({}, state, {
          isPending: true
        });
      case SUCCESS_TYPE:
        return (0, _objectAssign2.default)({}, state, {
          error: null,
          isPending: false,
          response: payload
        });
      case FAILURE_TYPE:
        return (0, _objectAssign2.default)({}, state, {
          error: payload,
          isPending: false
        });
      default:
        return state;
    }
  };
}
//# sourceMappingURL=reducer.js.map